import { render } from "./DSPyTestPage.vue?vue&type=template&id=69243e40&scoped=true"
import script from "./DSPyTestPage.vue?vue&type=script&lang=js"
export * from "./DSPyTestPage.vue?vue&type=script&lang=js"

import "./DSPyTestPage.vue?vue&type=style&index=0&id=69243e40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69243e40"]])

export default __exports__